export default __webpack_public_path__ + "static/media/AIPStatusALP.2e57a90f.png";